import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface ModalHeaderProps {
  sticky?: boolean;
}

const ModalHeader = styled.header<ModalHeaderProps>`
  position: relative;
  z-index: ${theme.zIndex.modal + 3};
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: ${toRem(8)} 0;
  background-color: ${theme.color.white};
  text-align: center;

  ${({ sticky }) =>
    sticky &&
    css`
      position: sticky;
      top: 0;
      padding-top: ${toRem(theme.modal.spacing.large)};
    `}
`;

export default ModalHeader;
